// File Metadata:
// Version: 1.00
// Created: 2025-03-19 23:09:16
// Authors: Dieuwer Descheemaecker
// Description: A brief summary of what this file does
// Last Modified: 2025-04-12 00:03:03
// Filename: AppLayout.jsx

import { useState } from 'react';
import Navbar from './Navbar';
import DrawerNav from './DrawerNav';
import MainContent from './MainContent';

const AppLayout = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => {
    // console.log('Toggling drawer, current state:', drawerOpen);
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <Navbar toggleDrawer={toggleDrawer} />
      <DrawerNav open={drawerOpen} toggleDrawer={toggleDrawer} />
      <MainContent>{children}</MainContent>
    </>
  );
};

export default AppLayout;